import { render } from "./Biography.vue?vue&type=template&id=2122cb02"
import script from "./Biography.vue?vue&type=script&lang=js"
export * from "./Biography.vue?vue&type=script&lang=js"

import "./Biography.vue?vue&type=style&index=0&id=2122cb02&lang=css"

import exportComponent from "F:\\Projects\\ym\\ym-biography\\biography-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__